import { useStaffConsultation } from '@/hooks/useStaffConsultation'
import { StaffConsultationCard } from './StaffConsultationCard'

interface StaffConsultationPanelProps {
  conversationId: string | undefined
  /** Una conversación cerrada ya no tiene dudas por resolver. */
  enabled: boolean
}

/**
 * Muestra la duda pendiente del asistente, si existe. Sin duda (o mientras carga) no ocupa espacio: la gran
 * mayoría de los chats no tiene ninguna y un esqueleto en cada apertura sería ruido.
 */
export function StaffConsultationPanel({ conversationId, enabled }: StaffConsultationPanelProps) {
  const { consultation, loadError, reload, answer, takeOver, isAnswering, isTakingOver, actionError } = useStaffConsultation(
    conversationId,
    enabled
  )

  if (loadError) {
    return (
      <p role="alert" className="mb-3 flex items-center justify-between gap-2 rounded-lg border border-rose-200 bg-rose-50 px-3 py-2 text-xs text-rose-800">
        <span>No pudimos revisar si hay dudas por resolver en este chat.</span>
        <button type="button" onClick={reload} className="font-semibold underline">
          Reintentar
        </button>
      </p>
    )
  }

  if (!consultation || consultation.status !== 'pending') return null

  return (
    <StaffConsultationCard
      key={consultation.id}
      consultation={consultation}
      isAnswering={isAnswering}
      isTakingOver={isTakingOver}
      error={actionError}
      onAnswer={(payload) => void answer(payload).catch(() => undefined)}
      onTakeOver={() => void takeOver().catch(() => undefined)}
    />
  )
}
